export default "__VITE_ASSET__BwCIB92j__"